import React from 'react'
import { useSelector } from 'react-redux'
import { CurrencyText } from 'views/components'
import { reportingApiSelectors } from 'modules/api/reporting'
import { TSuspenseStatsFigure } from 'modules/api/reporting/types'
import styles from './SuspenseSummary.module.scss'

interface SummaryCardProps {
  label: string
  figure?: TSuspenseStatsFigure
  countLabel: string
}

/** Shows a dash until the stats have loaded, rather than a misleading R 0.00. */
const SummaryCard = ({ label, figure, countLabel }: SummaryCardProps) => (
  <div className={styles.card}>
    <span className={styles.label}>{label}</span>
    <strong className={styles.total}>{figure ? <CurrencyText>{figure.total}</CurrencyText> : '—'}</strong>
    <span className={styles.count}>{figure ? `${figure.count} ${countLabel}` : ' '}</span>
  </div>
)

const SuspenseSummary = (): React.ReactElement => {
  const stats = useSelector(reportingApiSelectors.getSuspenseAccountStats)

  return (
    <div className={styles.root}>
      <SummaryCard label="Unallocated" figure={stats?.unallocated} countLabel="receipts" />
      <SummaryCard label="Allocated this month" figure={stats?.allocatedThisMonth} countLabel="receipts cleared" />
      <SummaryCard label="Allocated last month" figure={stats?.allocatedLastMonth} countLabel="receipts cleared" />
    </div>
  )
}

export default SuspenseSummary
